import { render, staticRenderFns } from "./uc.vue?vue&type=template&id=52fbdffe&"
import script from "./uc.vue?vue&type=script&lang=js&"
export * from "./uc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports